<template>
  <div>
    <v-progress-circular
      v-if="progressbar"
      :size="size + 6"
      :width="3"
      class="progress-bar"
      indeterminate
      color="primary"
    />
    <v-avatar
      :color="color"
      :size="size"
      :tile="tile"
    >
      <v-icon
        :style="iconStyle"
        :size="size - 10"
        color="white"
      >
        person
      </v-icon>
      <img
        :style="imgStyle"
        :src="downloadURL"
        @load="_imageLoaded"
      >
    </v-avatar>
    <input
      id="photoInput"
      ref="photoInput"
      accept="image/*"
      type="file"
      @change="_onFileSelect"
    >
    <v-snackbar
      v-model="snackbar"
      :color="snackbarColor"
      :timeout="0"
      bottom
    >
      {{ snackbarMessage }}
      <v-btn
        flat
        @click.native="snackbar = false"
      >
        Close
      </v-btn>
    </v-snackbar>
  </div>
</template>
<script>
import pica from 'pica';

import { storage } from '@/firebase';

export default {
  name: 'ProfilePhoto',
  props: {
    color: {
      type: String,
      default: 'primary'
    },
    size: {
      type: Number,
      default: 48
    },
    tile: {
      type: Boolean,
      default: false
    },
    /** Storage ref */
    src: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      progressbar: false,
      showPlaceholder: true,
      downloadURL: '',
      snackbar: false,
      snackbarMessage: '',
      snackbarColor: 'primary',
      changePasswordDialog: false
    };
  },
  computed: {
    imgStyle() {
      return {
        display: this.showPlaceholder ? 'none' : 'block'
      };
    },

    iconStyle() {
      return {
        display: this.showPlaceholder ? 'block' : 'none'
      };
    }
  },
  watch: {
    src: {
      handler(val) {
        storage
          .ref(val)
          .getDownloadURL()
          .then(url => {
            this.downloadURL = url;
          })
          .catch(() => {});
      },
      immediate: true
    }
  },
  methods: {
    _imageLoaded() {
      this.showPlaceholder = false;
    },

    _onFileSelect() {
      const input = this.$refs.photoInput;
      if (input.files && input.files[0]) {
        this.progressbar = true;

        const file = input.files[0];

        const img = new Image();
        img.src = URL.createObjectURL(file);
        img.onload = () => {
          const storageRef = storage.ref(
            `users/${this.$store.state.profile.uid}/photos/profile.png`
          );
          let canvasSize = img.width > img.height ? img.height : img.width;
          if (canvasSize > 512) canvasSize = 512;
          const canvas = document.createElement('canvas');
          canvas.width = canvasSize;
          canvas.height = canvasSize;
          pica()
            .resize(img, canvas)
            .then(result => pica().toBlob(result, 'image/jpeg', 0.9))
            .then(blob => storageRef.put(blob))
            .then(snapshot => {
              this.downloadURL = snapshot.downloadURL;
            })
            .catch((error /*eslint-disable-line*/) => {
              this.snackbarMessage =
                'Could not upload photo now! please try after sometime.';
              this.snackbarColor = 'error';
              this.snackbar = true;
            })
            .then(() => {
              this.progressbar = false;
            });
        };
      }
    },

    // public methods
    /**
     * Triggers photo change
     */
    changePhoto() {
      this.$refs.photoInput.click();
    }
  }
};
</script>
<style scoped>
.progress-bar {
  position: absolute;
  margin-left: -3px;
  margin-top: -3px;
}

#photoInput {
  display: none;
}
</style>
